class UiEventType {

	public static VIEW_LEAD_DETAIL = new UiEventType(1, "view_lead_detail");
	public static VIEW_ACTIVITY = new UiEventType(2, "view_activity");
	public static VIEW_SUBSCRIPTIONS = new UiEventType(3, "view_subscriptions");
	public static VIEW_EMAIL_ALERT_ACTIVITY = new UiEventType(4, "view_email_alert_activity");
	public static VIEW_PROPERTY_ORGANIZER = new UiEventType(5, "view_property_organizer");
	public static VIEW_FAVORITE_LISTINGS = new UiEventType(6, "view_favorite_listings");
	public static SORT_FAVORITE_LISTINGS = new UiEventType(7, "sort_favorite_listings");
	public static VIEW_SEARCH_AGENT = new UiEventType(8, "view_search_agent");
	public static VIEW_SEARCH_AGENT_CONVERSATION = new UiEventType(9, "view_search_agent_conversation");

	private constructor(
		public id: number,
		public eventName: string,
	) {}

	public static values(): UiEventType[] {
		return Object.values(UiEventType).filter(v => v instanceof UiEventType) as UiEventType[];
	}

	public static getById(id?: number): UiEventType | undefined {
		return this.values().find(value => value.id === id);
	}
}

export { UiEventType };
